module.exports = __webpack_public_path__ + "static/media/bottom2.a9173b7e.webp";